import { Component, EventEmitter, Input, Output } from '@angular/core';

import { PersonModel } from 'src/app/person/@shared/person.model';
import { fillSkeletonData } from 'src/app/@shared/app-helper';

@Component({
  // use onPush approach when performance is poor
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'person-preview',
  standalone: false,
  styleUrls: ['./person-preview.component.scss'],
  templateUrl: './person-preview.component.html',
})
export class PersonPreviewComponent {
  @Input() public type: 'thumbnail' | 'avatar' | 'card';

  @Output() public openDetail: EventEmitter<PersonModel> = new EventEmitter<PersonModel>();

  public showSkeleton: boolean = true;
  public subheadline: string = this.getSkeletonSubheadline();

  // fill item with skeleton data
  // !!!IMPORTANT!!! always use a skeleton wrapper (<span class="skeleton">...</span>) around the value
  // to ensure skeleton text (single- as well as multiline) works as expected
  private _item: Partial<PersonModel> = {
    addressCity: fillSkeletonData('city'),
    displayName: fillSkeletonData('title'),
    id: fillSkeletonData('id'),
  };

  @Input()
  public get item(): PersonModel {
    return this._item as PersonModel;
  }

  public set item(item: PersonModel | null) {
    // item is initially null (skeleton)
    if (!item) {
      return;
    }

    this._item = item as Partial<PersonModel>;
    this.subheadline = [this.item?.legacyId, this.item?.addressCity].filter(Boolean).join(' · ');
    this.showSkeleton = false;
  }

  private getSkeletonSubheadline(): string {
    return [fillSkeletonData('legacyId'), fillSkeletonData('city')].join(' · ');
  }
}
